import { REWARD_REQUEST_STATUSES } from '@/constants';
import { RewardRequestDisplayDTO } from '@/models';

export interface BulkStatusPayload {
  requestIds: number[];
  status: string;
  actualPrices: Record<number, number>;
}

export const isBulkSelectableRow = (item: RewardRequestDisplayDTO): boolean => {
  return (
    item.status === REWARD_REQUEST_STATUSES.PENDING.label ||
    item.status === REWARD_REQUEST_STATUSES.IN_PROGRESS.label
  );
};

export const canBulkMarkInProgress = (rows: RewardRequestDisplayDTO[]): boolean => {
  return rows.length > 0 && rows.every(row => row.status === REWARD_REQUEST_STATUSES.PENDING.label);
};

export const canBulkMarkCompleted = (rows: RewardRequestDisplayDTO[]): boolean => {
  return (
    rows.length > 0 &&
    rows.every(
      row =>
        row.status === REWARD_REQUEST_STATUSES.PENDING.label ||
        row.status === REWARD_REQUEST_STATUSES.IN_PROGRESS.label
    )
  );
};

export const buildBulkStatusPayload = (
  rows: RewardRequestDisplayDTO[],
  status: string
): BulkStatusPayload => {
  const requestIds = rows.map(row => row.id);
  const actualPrices: Record<number, number> = {};
  if (status === REWARD_REQUEST_STATUSES.APPROVED.label) {
    rows.forEach(row => {
      actualPrices[row.id] = row.actualPrice ?? row.estimatedPrice ?? 0;
    });
  }
  return { requestIds, status, actualPrices };
};
